var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCircleCheck = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "#19D296"
}, /*#__PURE__*/React.createElement("circle", {
  cx: 12,
  cy: 12,
  r: 12,
  fillOpacity: 0.1
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.364 7.987a.857.857 0 0 0-1.212 0L9.879 15.26l-3.03-3.03a.857.857 0 0 0-1.213 1.212l4.243 4.242L18.364 9.2a.857.857 0 0 0 0-1.212"
}))));
export default SvgCircleCheck;